import Button from 'components/Button';
import styled from 'styled-components';
import tw from 'twin.macro';

export const Wrapper = tw.div`w-full h-full flex justify-center items-center`;

export const PrevButton = styled(Button)`
  ${tw`absolute z-40 bottom-3 left-[4%] outline-none`};
`;

export const NextButton = styled(Button)`
  ${tw`absolute z-40 bottom-3 right-[4%] outline-none`};
`;
